/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InvoiceReconciliationRowResponseDto = {
    id: string;
    rowNumber: number;
    invoiceStatus: InvoiceReconciliationRowResponseDto.invoiceStatus;
    invoiceNumber: string;
    invoiceAmount: number;
    paidAmount: number;
    outstanding: number;
    matchedInvoiceId?: string | null;
    result: InvoiceReconciliationRowResponseDto.result;
    error?: string | null;
    createdAt: string;
};
export namespace InvoiceReconciliationRowResponseDto {
    export enum invoiceStatus {
        DRAFT = 'DRAFT',
        APPROVED = 'APPROVED',
        AWAITING_PAYMENT = 'AWAITING_PAYMENT',
        PART_PAID = 'PART_PAID',
        OVERDUE = 'OVERDUE',
        FAILED = 'FAILED',
        PAID = 'PAID',
        REFUNDED = 'REFUNDED',
        WRITTEN_OFF = 'WRITTEN_OFF',
        VOID = 'VOID',
    }
    export enum result {
        UPDATED = 'UPDATED',
        SKIPPED = 'SKIPPED',
        FAILED = 'FAILED',
        VOID = 'VOID',
    }
}

